import React, { useEffect, useState } from 'react';
import './styles.css';

const STORAGE_KEY = 'termsStatus';

export default function TermsBanner() {
  const [termsStatus, setTermsStatus] = useState('unknown');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    try {
      const storedValue = localStorage.getItem(STORAGE_KEY);
      const legacyValue = storedValue === null ? localStorage.getItem('termsAccepted') : null;
      const resolvedValue = storedValue ?? legacyValue;
      if (resolvedValue === 'accepted' || resolvedValue === 'true') {
        setTermsStatus('accepted');
        if (resolvedValue === 'true') {
          localStorage.setItem(STORAGE_KEY, 'accepted');
        }
      } else if (resolvedValue === 'rejected') {
        setTermsStatus('rejected');
      } else {
        setTermsStatus('unknown');
      }
    } catch (error) {
      setTermsStatus('unknown');
    }
  }, []);

  const acceptTerms = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'accepted');
    } catch (error) {
      // localStorage might be blocked; still allow acceptance for this session
    }
    setTermsStatus('accepted');
    window.dispatchEvent(new Event('termsStatusChange'));
    setShowModal(false);
  };

  const rejectTerms = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'rejected');
    } catch (error) {
      // localStorage might be blocked; still allow rejection for this session
    }
    setTermsStatus('rejected');
    window.dispatchEvent(new Event('termsStatusChange'));
    setShowModal(false);
  };

  if (termsStatus === 'accepted') {
    return null;
  }

  return (
    <>
      <div className="terms-banner" role="region" aria-label="Terms and conditions">
        <span className="terms-text">
          {termsStatus === 'rejected' ? (
            <>
              Changed my mind. I accept the{' '}
              <button
                type="button"
                className="terms-link-btn"
                onClick={() => setShowModal(true)}
              >
                terms and conditions
              </button>{' '}
              now.
            </>
          ) : (
            <>
              Please accept our{' '}
              <button
                type="button"
                className="terms-link-btn"
                onClick={() => setShowModal(true)}
              >
                terms and conditions
              </button>{' '}
              to enable all content.
            </>
          )}
        </span>
        <div className="terms-actions">
          <button type="button" className="terms-button accept" onClick={acceptTerms}>
            Accept
          </button>
          {termsStatus !== 'rejected' && (
            <button type="button" className="terms-button reject" onClick={rejectTerms}>
              Reject
            </button>
          )}
        </div>
      </div>

      {showModal && (
        <div className="terms-modal-backdrop" role="presentation">
          <div className="terms-modal" role="dialog" aria-modal="true" aria-label="Terms and conditions">
            <div className="terms-modal-body">
              <h3>Terms and Conditions</h3>
              <p>
                This website is provided for entertainment and informational purposes only. Content
                may change without notice and should not be considered professional advice. By using
                this site, you agree to do so at your own risk and accept that the site is provided
                &quot;as is&quot; without warranties of any kind.
              </p>
              <p>
                The site may include embedded content from third parties (such as YouTube and
                Instagram). Those services may collect data or use cookies according to their own
                policies and terms.
              </p>
              <p>
                Links to external sites are provided for convenience only. We are not responsible
                for their content, availability, or practices. Trademarks and logos belong to their
                respective owners.
              </p>
              <p>
                We may update these terms from time to time. Continued use of the site constitutes
                acceptance of the latest version.
              </p>
            </div>
            <div className="terms-actions modal-actions">
              <button type="button" className="terms-button accept" onClick={acceptTerms}>
                Accept
              </button>
              <button type="button" className="terms-button reject" onClick={rejectTerms}>
                Reject
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
